import { render, staticRenderFns } from "./UTableQuiz.vue?vue&type=template&id=4287e1e5&scoped=true&"
import script from "./UTableQuiz.vue?vue&type=script&lang=js&"
export * from "./UTableQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287e1e5",
  null
  
)

export default component.exports